import { useState } from 'react';
import { convertFile } from '../../../apiServices/resourceApi';
import { Button } from '../../ui/Button';
import { Spinner } from '../../ui/Spinner';
import { useNotification } from '@/hooks/useNotification';

interface ConvertModalProps {
  item: { id: string; name: string };
  updateIsQuerying: (querying: boolean) => void;
  refreshList: () => void;
}

export function ConvertModal({ item, updateIsQuerying, refreshList }: ConvertModalProps) {
  const [loading, setLoading] = useState(false);
  const { notify } = useNotification();

  const convert = async () => {
    try {
      setLoading(true);
      updateIsQuerying(true);
      await convertFile(item.id);
      updateIsQuerying(false);
      refreshList();
      notify({ type: 'success', message: 'Conversion process started, file will appear on refresh' });
    } catch {
      refreshList();
      notify({ type: 'error', message: 'Could not convert file' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-4">
      <h4 className="text-lg font-semibold">{`Convert file "${item.name}" to MP4?`}</h4>
      <Button onClick={convert} disabled={loading}>
        {loading && <Spinner size="sm" />}
        Convert
      </Button>
    </div>
  );
}
